import { trigger, state, style, transition, animate, group, query, stagger, keyframes } from '@angular/animations';

export const FadeInOut = [
  trigger('fadeInOut', [
    transition(':enter', [style({ opacity: 0 }), animate('500ms', style({ opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1 }), animate('25ms', style({ opacity: 0 }))])
  ])
];
